import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.06 14.73L14.73 16.06L12 13.33L9.27 16.06L7.94 14.73L10.67 12L7.94 9.27L9.27 7.94L12 10.67L14.73 7.94L16.06 9.27L13.33 12L16.06 14.73Z" fill={ fill || 'currentColor' } />
    </svg>
);
